var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SystemProgram, Transaction } from "@solana/web3.js";
import { getProgram } from "../utils/getProgram.obj";
import { getSwapDataAccountFromPublicKey } from "../utils/getSwapDataAccountFromPublicKey.function";
import { getSwapIdentityFromData } from "../utils/getSwapIdentityFromData.function";
import { getDepositNftInstruction } from "./subFunction/deposit.nft.instructions";
import { getDepositSolInstruction } from "./subFunction/deposit.sol.instructions";
import { ItemStatus, TradeStatus } from "../utils/types";
import { getDepositCNftInstruction } from "./subFunction/deposit.cnft.instructions";
export function createDepositSwapInstructions(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var program, swapData, swapIdentity, depositInstruction, ataList, isUserPartOfTrade, isUserAlreadyDeposited, swapDataItems, _i, swapDataItems_1, swapDataItem, ix, depositing, tokenName, depositSolInstruction;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    program = Data.program ? Data.program : getProgram({ clusterOrUrl: Data.clusterOrUrl });
                    return [4 /*yield*/, getSwapDataAccountFromPublicKey({
                            program: program,
                            swapDataAccount_publicKey: Data.swapDataAccount,
                        })];
                case 1:
                    swapData = _c.sent();
                    // console.log("swapData", swapData);
                    if (!swapData) {
                        throw {
                            blockchain: "solana",
                            status: "error",
                            message: "Swap initialization in progress or not initialized. Please try again later.",
                        };
                    }
                    else if (swapData.status !== TradeStatus.WaitingToDeposit)
                        throw {
                            blockchain: "solana",
                            status: "error",
                            message: "Status of the swap isn't in a depositing state.",
                            swapStatus: swapData.status,
                        };
                    swapIdentity = getSwapIdentityFromData({
                        swapData: swapData,
                        clusterOrUrl: Data.clusterOrUrl,
                    });
                    console.log("swapIdentity", swapIdentity);
                    depositInstruction = [];
                    ataList = [];
                    isUserPartOfTrade = false;
                    isUserAlreadyDeposited = false;
                    swapDataItems = swapData.items.filter(function (item) { return item.owner.equals(Data.user); });
                    // console.log("swapDataItems", swapDataItems);
                    if (swapDataItems.length > 0)
                        isUserPartOfTrade = true;
                    _i = 0, swapDataItems_1 = swapDataItems;
                    _c.label = 2;
                case 2:
                    if (!(_i < swapDataItems_1.length)) return [3 /*break*/, 13];
                    swapDataItem = swapDataItems_1[_i];
                    if (!swapDataItem.isNft) return [3 /*break*/, 9];
                    if (!(swapDataItem.status === ItemStatus.NFTPending)) return [3 /*break*/, 7];
                    if (!swapDataItem.isCompressed) return [3 /*break*/, 4];
                    console.log("XXX - Deposit CNFT item with TokenId ", swapDataItem.mint.toBase58(), " from ", swapDataItem.owner.toBase58(), " - XXX");
                    return [4 /*yield*/, getDepositCNftInstruction({
                            program: program,
                            signer: Data.user,
                            swapIdentity: swapIdentity,
                            tokenId: swapDataItem.mint,
                            clusterOrUrl: Data.clusterOrUrl,
                        })];
                case 3:
                    ix = _c.sent();
                    if (!ix.instructions)
                        throw " error prepare Instruction";
                    depositInstruction.push({
                        tx: new Transaction().add(ix.instructions),
                    });
                    return [3 /*break*/, 6];
                case 4:
                    console.log("XXX - Deposit NFT item with mint ", swapDataItem.mint.toBase58(), " from ", swapDataItem.owner.toBase58(), " - XXX");
                    return [4 /*yield*/, getDepositNftInstruction({
                            program: program,
                            signer: Data.user,
                            mint: swapDataItem.mint,
                            amount: swapDataItem.amount.toNumber(),
                            swapIdentity: swapIdentity,
                            ataList: ataList,
                        })];
                case 5:
                    depositing = _c.sent();
                    depositing.newAtas.forEach(function (element) {
                        if (!ataList.includes(element)) {
                            ataList.push(element);
                        }
                    });
                    depositInstruction.push({
                        tx: (_a = new Transaction()).add.apply(_a, depositing.instructions),
                    });
                    _c.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    if (swapDataItem.status === ItemStatus.NFTDeposited) {
                        isUserAlreadyDeposited = true;
                    }
                    _c.label = 8;
                case 8: return [3 /*break*/, 12];
                case 9:
                    if (!(swapDataItem.status === ItemStatus.SolPending)) return [3 /*break*/, 11];
                    tokenName = "SOL";
                    switch (swapData.acceptedPayement.toString()) {
                        case "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v":
                            tokenName = "USCD";
                            break;
                        case "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx":
                            tokenName = "ATLAS";
                            break;
                        case "6dhTynDkYsVM7cbF7TKfC9DWB636TcEM935fq7JzL2ES":
                            tokenName = "BONK";
                            break;
                        case "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz":
                            tokenName = "GENOPETS";
                            break;
                        case SystemProgram.programId.toBase58():
                            tokenName = "SOL";
                            break;
                    }
                    console.log("XXX - Deposit ".concat(tokenName, " item with mint "), swapDataItem.mint.toBase58(), " from ", swapDataItem.owner.toBase58(), " - XXX");
                    return [4 /*yield*/, getDepositSolInstruction({
                            program: program,
                            signer: Data.user,
                            amount: swapDataItem.amount.toNumber(),
                            swapIdentity: swapIdentity,
                            ataList: ataList,
                            mint: swapDataItem.mint,
                        })];
                case 10:
                    depositSolInstruction = _c.sent();
                    depositInstruction.push({
                        tx: (_b = new Transaction()).add.apply(_b, depositSolInstruction.instructions),
                    });
                    return [3 /*break*/, 12];
                case 11:
                    if (swapDataItem.status === ItemStatus.SolDeposited) {
                        isUserAlreadyDeposited = true;
                    }
                    _c.label = 12;
                case 12:
                    _i++;
                    return [3 /*break*/, 2];
                case 13:
                    if (isUserPartOfTrade === false) {
                        throw {
                            blockchain: "solana",
                            status: "error",
                            message: "You are not a part of this swap",
                        };
                    }
                    else if (depositInstruction.length === 0 &&
                        isUserPartOfTrade === true &&
                        isUserAlreadyDeposited === true) {
                        throw {
                            blockchain: "solana",
                            status: "error",
                            message: "You have already escrowed your items in this swap",
                        };
                    }
                    else if (depositInstruction.length === 0 && isUserPartOfTrade === true) {
                        throw {
                            blockchain: "solana",
                            status: "error",
                            message: "You have no items to escrow in this swap",
                        };
                    }
                    console.log("found ", depositInstruction.length, " items to deposit");
                    return [2 /*return*/, depositInstruction];
            }
        });
    });
}
